export const TYPES = {
  SHOW_POPOVER: 'SHOW_POPOVER',
  HIDE_POPOVER: 'HIDE_POPOVER',
  TOGGLE_POPOVER: 'TOGGLE_POPOVER',
};

export const showPopover = (data, content) => ({
  type: TYPES.SHOW_POPOVER,
  data,
  content,
});
export const togglePopover = (data, content) => ({
  type: TYPES.TOGGLE_POPOVER,
  data,
  content,
});
export const hidePopover = () => ({ type: TYPES.HIDE_POPOVER });



/** WEBPACK FOOTER **
 ** ./src/redux/actions/popoverActions.js
 **/